import { forwardRef, useCallback, useEffect, useRef } from "react";
import ReactOwlCarousel from "react-owl-carousel";

export const OwlCarousel = forwardRef((props, ref) => {
  const instanceRef = useRef(null);

  const setInstance = useCallback(
    (instance) => {
      if (instance) instanceRef.current = instance;
      if (typeof ref === "function") ref(instance);
      else if (ref) ref.current = instance;
    },
    [ref],
  );

  useEffect(() => {
    const instance = instanceRef.current;
    return () => {
      const $element = instance?.$ele;
      if ($element?.data("owl.carousel")) $element.trigger("destroy.owl.carousel");
    };
  }, []);

  return <ReactOwlCarousel ref={setInstance} {...props} />;
});
